import {
  DueOutHistory,
  DueOutHistoryArgs,
  //getDueOutHistory,
  getDueOutHistoryItems,
} from '../../assets/ts/data/dueout/dueout-history'
import useServerData from '../use-server-data'

function useDueoutHistory(fetchArgs, waitOnParentDependency = false) {
  const {
    data:  dueOutHistory,
    error: dueoutHistoryError,
    fetchData: fetchDueoutHistory,
    isLoading: dueoutHistoryIsLoading,
  } = useServerData<DueOutHistory, DueOutHistoryArgs>(
    // getDueOutHistory, 
    getDueOutHistoryItems,
    fetchArgs,
    waitOnParentDependency
  )
  return {
    dueOutHistory,
    dueoutHistoryError,
    dueoutHistoryIsLoading,
    fetchDueoutHistory,
    refetch: fetchDueoutHistory, // For re-fetching
  }
}

export default useDueoutHistory
